import React from "react";
import { string } from "prop-types";

import "./section-link.m.css";

import { Link } from "@quintype/components";
import { RightArrowIcon } from "../../../../assets/icons/RightArrowIcon";
import { getLinkTarget } from "../../../arrow/utils/utils";

const SectionLink = ({ children, href, noTopPadding, ...props }) => {
  const content = (
    <>
      <span styleName="link-text">{children}</span>
      <span className="icon-wrapper">
        <RightArrowIcon />
      </span>
    </>
  );

  return (
    <div styleName={noTopPadding ? "section-link-no" : "section-link"}>
      {href ? (
        <Link href={href} styleName="link-wrapper" aria-label="section-link" target={getLinkTarget(href)} rel="noopener" {...props}>
          {content}
        </Link>
      ) : (
        <button styleName="link-wrapper" aria-label="section-link" {...props}>
          {content}
        </button>
      )}
    </div>
  );
};

SectionLink.propTypes = {
  children: string.isRequired,
  href: string
};

export default SectionLink;
